import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { RegularPaymentResult } from '../../Models/Models/Payments/RegularPayment/RegularPaymentResult';

declare var IS_RUNNING_IN_APP_POOL;

export class CheckRegularPaymentAutolineCompletedClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(regularBuyId: number): Promise<RegularPaymentResult, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Payments/CheckRegularPaymentAutolineCompleted/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { regularBuyId: regularBuyId }

    return AjaxWrapper.get<RegularPaymentResult, any>(url, data);
  }
}

